/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Flow Do API
 * API таск-менеджера Flow Do. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorModel,
  ResultBody,
  SearchParams
} from '../model';

import { apiFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type searchResponse200 = {
  data: ResultBody
  status: 200
}

export type searchResponse404 = {
  data: ErrorModel
  status: 404
}

export type searchResponse422 = {
  data: ErrorModel
  status: 422
}

export type searchResponse500 = {
  data: ErrorModel
  status: 500
}

export type searchResponseSuccess = (searchResponse200) & {
  headers: Headers;
};
export type searchResponseError = (searchResponse404 | searchResponse422 | searchResponse500) & {
  headers: Headers;
};

export type searchResponse = (searchResponseSuccess | searchResponseError)

export const getSearchUrl = (slug: string,
    params?: SearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/workspaces/${slug}/search?${stringifiedParams}` : `/workspaces/${slug}/search`
}

/**
 * Задачи, комментарии, страницы, люди и проекты одним запросом — для палитры ⌘K. Слова совпадают по основе и по началу («опла» найдёт «оплату»), ключ задачи — по номеру. Показывается только то, что спрашивающий и так видит. Пустой запрос — пустые группы.
 * @summary Поиск по организации
 */
export const search = async (slug: string,
    params?: SearchParams, options?: Parameters<typeof apiFetch>[1]): Promise<searchResponse> => {

  return apiFetch<searchResponse>(getSearchUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchQueryKey = (slug: string,
    params?: SearchParams,) => {
    return [
    `/workspaces/${slug}/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchQueryOptions = <TData = Awaited<ReturnType<typeof search>>, TError = ErrorModel>(slug: string,
    params?: SearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof search>>> = ({ signal }) => search(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchQueryResult = NonNullable<Awaited<ReturnType<typeof search>>>
export type SearchQueryError = ErrorModel


export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorModel>(
 slug: string,
    params: undefined |  SearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof search>>,
          TError,
          Awaited<ReturnType<typeof search>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorModel>(
 slug: string,
    params?: SearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof search>>,
          TError,
          Awaited<ReturnType<typeof search>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorModel>(
 slug: string,
    params?: SearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Поиск по организации
 */

export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorModel>(
 slug: string,
    params?: SearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






